import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {LoaderService, NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';

@Component({
  selector: 'camera-payment',
  templateUrl: './camera-payment.component.html',
  styleUrls: ['./camera-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CameraPaymentComponent implements OnInit{
  webcamImage: string;
  showCamera = false;
  type: string;
  constructor(private nav: NavigateService,
    private cart: CartService, private loader: LoaderService) {
  }

  ngOnInit(): void {
    this.loader.loading(true);
    setTimeout(() => {
      this.loader.loading(false);
      this.showCamera = true;
    }, 1500);
  }


  setPicture(imageUrl: string) {
    this.webcamImage = imageUrl;
    this.cart.selfiePerson = imageUrl;
  }

  close() {
    this.webcamImage = '';
    this.cart.selfiePerson = undefined;
  }

  confirm() {
    this.nav.to('means-payment');
  }


}


